import React, { useContext, useEffect, useState } from 'react';
import {
  DialogContent,
  LinearProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  Alert,
} from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { IPickupTask } from '../../../../interfaces/delivery-company/tasks';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import axios from 'axios';
import { IWarehouseShelf } from '../../../../interfaces/delivery-company/warehouseshelf';
import { ShelfPrinter } from '../../../common/shelf-barcode-printer/shelf-barcode-printer';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';

interface ShelfQRCodeDownloadProps {
  shelf: IWarehouseShelf;
  onClose: () => void;
}

function ShelfQRCodeDownload({ shelf, onClose }: ShelfQRCodeDownloadProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { user, config } = useContext(AuthContext);

  return (
    <CustomDialog open={isOpen} onClose={onClose} maxWidth="md">
      <div
        style={{
          textAlign: 'right',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <DialogTitle>Shelf QR Code</DialogTitle>
        <IconButton
          onClick={() => {
            onClose && onClose();
            setIsOpen(false);
          }}
        >
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent
        style={
          (isDesktop || isTablet)
            ? { width: 'auto', height: 'auto', textAlign: 'center' }
            : {}
        }
      >
        <PDFDownloadLink
          document={<ShelfPrinter shelf={shelf} />}
          fileName={`${shelf.label}.${shelf.id}.pdf`}
        >
          {({ loading }: {loading: boolean}) => {
            return loading ? (
              <Button
                size={(isMobile && !isTablet) ? 'small' : 'medium'}
                color="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button size={(isMobile && !isTablet) ? 'small' : 'medium'} color="primary">
                <DownloadIcon fontSize="large" />
              </Button>
            );
          }}
        </PDFDownloadLink>
      </DialogContent>
    </CustomDialog>
  );
}

export default ShelfQRCodeDownload;
